import React from "react";
import { FaSearch } from "react-icons/fa";
import SearchBar from "./ui/search-bar"; 
import PageTop from "../../ui/page-top";


//
export default  function SearchQueryHome() {
  return (
    <React.Fragment>
      <PageTop page={{ noheader: true }} />
      <div className="page-body py30">
        <h1 className="flex align-items-center">
         
          <FaSearch className="pr5"/> Search Products
        </h1>
        <div className="page-vertical-pad">
          <SearchBar />
        </div>
      </div>
    </React.Fragment>
  );
}
